import { IAutomationObject } from "../../../types"
import { schema as schemaMultistate } from '../../../Devices/MultiState/types'
import { schema as schemaMultistateSwitch } from '../../../Devices/MultiStateSwitch/types'
import { schema as schemaFault } from '../../../Devices/SensorDigitalFault/types'
import { schema as schemaAlarm } from '../../../Devices/SensorDigitalAlarm/types'
import { schema as schemaState } from '../../../Devices/SensorDigital/types'
import { FormattedMessage } from "react-intl";
import FilteredAppsView, { ISchemaSortDictionary, sortBySchema } from "../../../components/FilteredAppsView/FilteredAppsView"

const PlantSwitchesGrid = (props: { childElements: IAutomationObject[] | undefined }) => {
    return (
        <FilteredAppsView
            header={<FormattedMessage id="P_AirHandling.Plantswitch" defaultMessage={'Plantswitch'} />}
            apps={props.childElements ?? []}
            filter={filterPlantSwitches}
            sort={(a, b) => sortBySchema(a, b, sortDict)}>
        </FilteredAppsView>
    )
}

export default PlantSwitchesGrid;

export const filterPlantSwitches = (v: IAutomationObject) => {
    return v.schema === schemaMultistate
        || v.schema === schemaMultistateSwitch
        || v.schema === schemaFault
        || v.schema === schemaAlarm
        || v.schema === schemaState
}
const sortDict: ISchemaSortDictionary = {
    schemaMultistate: 1,
    schemaMultistateSwitch: 2,
    schemaFault: 3,
    schemaAlarm: 3,
    schemaState: 3,
}